import { linkFromTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case linkFromTypes.SET_LINK_FROM:
            return {
                [action.linkFrom]: true
            };
        default:
            return state;
    }
};